import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import './subscription.css';

const SubscriptionCancel = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/user/subscription');
  };

  const handleGoToDashboard = () => {
    navigate('/user/dashboard');
  };

  return (
    <div className="subscription-cancel-page">
      <div className="subscription-cancel-container">
        <div className="subscription-cancel-content">
          <div className="cancel-icon">
            <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="40" cy="40" r="40" fill="#EF4444" opacity="0.1"/>
              <path d="M40 20C28.9543 20 20 28.9543 20 40C20 51.0457 28.9543 60 40 60C51.0457 60 60 51.0457 60 40C60 28.9543 51.0457 20 40 20ZM45 35L40 40L45 45L35 45L30 40L35 35L45 35Z" fill="#EF4444"/>
            </svg>
          </div>
          <h1>Payment Cancelled</h1>
          <p className="cancel-message">
            Your subscription payment was cancelled. No charges have been made to your account.
          </p>
          <p className="cancel-submessage">
            If you encountered any issues during checkout, please try again or contact our support team for assistance.
          </p>
          <div className="cancel-actions">
            <button 
              className="btn-primary" 
              onClick={handleGoBack}
            >
              Try Again
            </button>
            <button 
              className="btn-secondary" 
              onClick={handleGoToDashboard}
            >
              Go to Dashboard
            </button>
          </div>
        </div>
      </div>
      <style>{`
        .subscription-cancel-page {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
          padding: 20px;
        }
        .subscription-cancel-container {
          background: white;
          border-radius: 12px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
          max-width: 600px;
          width: 100%;
          padding: 40px;
          text-align: center;
        }
        .subscription-cancel-content {
          animation: fadeIn 0.5s ease-in;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .cancel-icon {
          margin-bottom: 24px;
        }
        .subscription-cancel-container h1 {
          color: #1f2937;
          font-size: 32px;
          font-weight: 700;
          margin-bottom: 16px;
        }
        .cancel-message {
          color: #6b7280;
          font-size: 18px;
          line-height: 1.6;
          margin-bottom: 12px;
        }
        .cancel-submessage {
          color: #9ca3af;
          font-size: 14px;
          line-height: 1.6;
          margin-bottom: 32px;
        }
        .cancel-actions {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
        }
        .btn-primary, .btn-secondary {
          padding: 12px 24px;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          border: none;
        }
        .btn-primary {
          background: #667eea;
          color: white;
        }
        .btn-primary:hover {
          background: #5568d3;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
        }
        .btn-secondary {
          background: white;
          color: #667eea;
          border: 2px solid #667eea;
        }
        .btn-secondary:hover {
          background: #f3f4f6;
          transform: translateY(-2px);
        }
      `}</style>
    </div>
  );
};

export default SubscriptionCancel;

